function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { convertTimestampToDate } from './generics-conversion-service';
export var serviceKey = function serviceKey(_ref, i) {
  var serviceIdentity = _ref.serviceIdentity,
    turnaroundTime = _ref.turnaroundTime,
    wordCount = _ref.wordCount,
    figureCount = _ref.figureCount,
    tableCount = _ref.tableCount;
  return JSON.stringify({
    serviceIdentity: serviceIdentity,
    turnaroundTime: turnaroundTime,
    wordCount: wordCount,
    figureCount: figureCount,
    tableCount: tableCount,
    i: i
  });
};
export var convertServiceOptionsToJson = function convertServiceOptionsToJson(json) {
  var serviceOptions = json.serviceOptions.map(function (detailsObject, i) {
    return _objectSpread(_objectSpread({}, detailsObject), {}, {
      deadline: convertTimestampToDate(detailsObject.deadline),
      key: serviceKey(detailsObject, i)
    });
  });
  return {
    serviceOptions: serviceOptions
  };
};
export default convertServiceOptionsToJson;